/** @format */
import { css } from 'styled-components';

import {
    mobile,
    smallMobile,
    smallTablet,
} from '@toucan/helpers/media-queries';

import { LayoutProps, LayoutType } from './index';

/**
 * Base styles for the layout component
 *
 * */
const baseStyles = () => css`
    height: 100%;
`;

/**
 * Base styles for the layout component
 *
 * @param {LayoutProps} props The layout properties object
 * @param {LayoutProps} props.layoutType The layout type
 * */
const layoutTypeStyles = ({ layoutType }: LayoutProps) => {
    switch (layoutType) {
        case LayoutType.MINIMAL:
            return css`
                text-align: center;
                display: flex;
                flex-direction: column;

                main {
                    max-width: 62.5rem;
                    margin: 0 auto;
                    padding: 1.2rem 2.4rem 2.4rem;
                }

                header {
                    padding: 4.8rem 2.4rem 1.2rem;
                }

                .logo {
                    align-items: center;
                }
            `;

        case LayoutType.CHECKOUT:
            return css`
                margin-bottom: var(--layout-spacing-48);
                display: flex;
                flex-direction: column;

                ${smallTablet(css`
                    margin-bottom: var(--layout-spacing-72);
                `)}
            `;
        case LayoutType.QUOTE:
            return css`
                display: flex;
                flex-direction: column;
            `;
        case LayoutType.ORIGINAL_CONTENT:
            return css`
                section:nth-last-of-type(2) {
                    padding-bottom: calc(
                        10rem + var(--original-content-bleed-padding)
                    );
                }

                ${smallTablet(css`
                    section:nth-last-of-type(2) {
                        padding-bottom: calc(
                            13rem + var(--original-content-bleed-padding)
                        );
                    }

                    .site-footer {
                        display: none;
                    }
                `)}

                ${mobile(css`
                    section:nth-last-of-type(2) {
                        padding-bottom: calc(
                            16rem + var(--original-content-bleed-padding)
                        );
                    }
                `)}

                ${smallMobile(css`
                    section:nth-last-of-type(2) {
                        padding-bottom: calc(19rem);
                    }
                `)}
            `;
        case LayoutType.FULL:
        default:
            return css``;
    }
};

/**
 * The layout component styles
 *
 * @param {LayoutProps} props The layout properties object
 * */
export const styles = (props: LayoutProps) => css`
    ${baseStyles()}
    ${layoutTypeStyles(props)}
`;
